import { FC, useEffect } from "react";
import "./AdminDialog.css";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import {
  adminGetMessageByTicketId,
  adminGetTicketById,
} from "../../../redux/requests/AdminRequests";
import dayjs from "dayjs";

interface IAdminDialogProps {}

const AdminDialog: FC<IAdminDialogProps> = () => {
  const params = useParams();
  const ticketId = Number(params.id);

  const dispatch = useAppDispatch();

  const { messages, tickets, isLoading, error } = useAppSelector(
    (state) => state.admin
  );

  const ticket = tickets.find((item) => item.id === ticketId);

  useEffect(() => {
    if (ticketId) {
      if (!ticket) {
        dispatch(adminGetTicketById(ticketId));
      }
      dispatch(adminGetMessageByTicketId(ticketId));
    }
  }, [ticketId, ticket, dispatch]);

  if (isLoading && !ticket) return <div>Загрузка...</div>;
  if (error) return <div>Ошибка: {error}</div>;
  if (!ticket) return <div>Диалог не найден</div>;

  return (
    <div className="dialog">
      <div className="ticket-data">
        <div className="ticket-data-item">
          <h2>Клиент:</h2>
          <h2>{ticket?.user.name || "Неизвестный клиент"}</h2>
        </div>

        <div className="ticket-data-item">
          <h2>Оператор:</h2>
          <h2>{ticket?.operator?.name || "Неизвестный оператор"}</h2>
        </div>

        <div className="ticket-data-item">
          <h2>Вопрос:</h2>
          <h2>{ticket?.question}</h2>
        </div>

        <div className="ticket-data-item">
          <h2>Создано:</h2>
          <h2>
            {ticket?.createdAt
              ? dayjs(ticket.createdAt).format("DD-MM-YY HH:mm")
              : "-"}
          </h2>
        </div>

        <div className="ticket-data-item">
          <h2>Принято:</h2>
          <h2>
            {ticket?.acceptedAt
              ? dayjs(ticket.acceptedAt).format("DD-MM-YY HH:mm")
              : "-"}
          </h2>
        </div>

        <div className="ticket-data-item">
          <h2>Закрыто:</h2>
          <h2>
            {ticket?.closedAt
              ? dayjs(ticket.closedAt).format("DD-MM-YY HH:mm")
              : "-"}
          </h2>
        </div>

        <div className="ticket-data-item">
          <h2>Оценка</h2>
          <h2>{ticket?.mark}</h2>
        </div>
      </div>

      <div className="chat-area-dialog">
        <div className="chat-box-dialog active-chat">
          {messages.map((item) => {
            const localTime = dayjs(item.sent_at).format("HH:mm");

            return (
              <div
                className={`message-dialog ${
                  item.operatorId
                    ? "operator-message-dialog"
                    : "user-message-dialog"
                }`}
                key={item.id}
              >
                {item.type === "photo" ? (
                  <div className="photo-message-dialog">
                    <img
                      src={item.photoUrl || ""}
                      alt={item.caption || "photo"}
                      className="message-photo-dialog"
                    />
                    {item.caption && <p>{item.caption}</p>}
                  </div>
                ) : (
                  <p>{item.content}</p>
                )}

                <span className="timestamp-dialog">{localTime}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminDialog;